export const EXPERIENCE_START_YEAR = 2010;

export function getKstYear(date: Date = new Date()) {
  const year = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
  }).format(date);
  return Number(year);
}

export function getExperienceYears(startYear: number = EXPERIENCE_START_YEAR, date: Date = new Date()) {
  const year = getKstYear(date);
  return Math.max(0, year - startYear + 1);
}
